import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-logged-out',
  templateUrl: './logged-out.component.html',
  styleUrls: ['./logged-out.component.scss'],
  encapsulation: ViewEncapsulation.None // Apply global styles
})


export class LoggedOutComponent implements OnInit { 

  isPPI: boolean = false;
  portalLink: string = '';
  portalName: string = '';
  phoneNo: string = '';
  someData:string = '';

  constructor(
    private location:Location
  ){
    this.disableBackButton();
  }

  ngOnInit(): void {
   this.isPPI = sessionStorage.getItem('isPPI') === 'true';
   if (this.isPPI) {
      this.portalLink = 'https://www.parcelpro.com/';
      this.portalName = 'ParcelPro online portal';
      this.phoneNo = '1-888-683-2300';

    } else {
      this.portalLink = 'https://www.insureshield.com/';
      this.portalName = 'InsureShield online portal';
      this.phoneNo = '1-811-263-8772';
    }
  }

  disableBackButton() {
    this.location.replaceState('/logged-out');
    window.history.pushState(null, '', '/logged-out');
    window.onpopstate = () => {
      this.location.go('/logged-out');
    };
  }


tabClose(): void {

  window.close();
  console.log('close clicked')
}

}
